export default () => {
  return {
    block_ui: false,
    theme: 'dark',
    location: '',
    loginAttempts: 0,
    newsletterAttempts: 0,
  }
}
